<div class="container-close">
  <mat-icon (click)="matDialogRef.close()">close</mat-icon>
</div>
<div class="perfil-container">
  <div class="perfil-card">
    <!-- Foto de perfil -->
    <div class="avatar-section">
      <img
        class="avatar"
        src="../../../../../../assets/images/Sachacabrona.jpeg"
        alt="Foto de perfil"
      />

      <button mat-stroked-button color="primary">Cambiar foto</button>
    </div>

    <!-- Datos del usuario -->
    <form class="datos-form">
      <mat-form-field appearance="outline">
        <mat-label>Nombre completo</mat-label>
        <input matInput placeholder="Ej: Iván Cairoli" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput type="email" placeholder="usuario@mail.com" />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Teléfono</mat-label>
        <input matInput type="tel" placeholder="Ej: +54 9 341..." />
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Descripción / Bio</mat-label>
        <textarea
          matInput
          rows="3"
          placeholder="Contanos sobre vos..."
          style="resize: none"
        ></textarea>
      </mat-form-field>

      <button mat-flat-button color="primary" class="btn-guardar">
        Guardar cambios
      </button>
    </form>
  </div>
</div>
